<div>
	<main [ngClass]="'step-' + selectedStepperIndex" *ngIf="hasEligibility">
		<mat-horizontal-stepper #stepper [linear]="true" (selectionChange)="changeInStepper($event)">
			<mat-step>
				<ng-template matStepLabel>
					<span class="mat-step-label-count">1</span>
					<span class="mat-step-label-title" [translate]="'referral.request-referral.stepper.select-specialty.title'"
						>. Select Specialty</span
					>
				</ng-template>
				<div class="col-md-12">
					<app-ehe-select-speciality
						(getSpecialities)="valueFromSelectSpecialty($event)"
						[stepper]="stepper"
						[resetForm]="reset"></app-ehe-select-speciality>
				</div>
			</mat-step>
			<mat-step>
				<ng-template matStepLabel>
					<span class="mat-step-label-count">2</span>
					<span class="mat-step-label-title" [translate]="'referral.request-referral.stepper.add-details.title'"
						>. Add Details</span
					>
				</ng-template>
				<div class="col-md-12">
					<app-ehe-add-details
						[speciality]="specialities"
						(getDetails)="valueFromAddDetails($event)"
						[stepper]="stepper"
						(resetEvent)="reset = $event"></app-ehe-add-details>
				</div>
			</mat-step>
			<mat-step>
				<ng-template matStepLabel>
					<span class="mat-step-label-count">3</span>
					<span class="mat-step-label-title" [translate]="'referral.request-referral.stepper.specify-preferences.title'"
						>. Specify Preferences</span
					>
				</ng-template>
				<div class="col-md-12">
					<app-ehe-specify-preferences
						[requestReferralDetails]="details"
						[stepper]="stepper"
						(resetEvent)="reset = $event"></app-ehe-specify-preferences>
				</div>
			</mat-step>
		</mat-horizontal-stepper>
	</main>
</div>
